// extracted by mini-css-extract-plugin
export default {"panel":"storage-node-panel_panel__yGtym"};